// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://js.arcgis.com/4.28/@arcgis/core/assets/esri/themes/light/main.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Load the ESRI javascript SDK css file. Custom! API Version */

body {
   overflow-y: hidden;
   /*background-color: LightSteelBlue ivory cornsilk ghostWhite, gainsboro */
}

/* Flex box rows. */
.app-flex-row-around {
   display: flex;
   justify-content: space-around;
   align-items: center;
}

.app-flex-row-between {
   display: flex;
   justify-content: space-between;
   align-items: center;
}

.app-flex-row-center {
   display: flex;
   justify-content: center;
   align-items: center;
}

.app-flex-row-evenly {
   display: flex;
   justify-content: space-evenly;
   align-items: center;
}

.app-flex-row-start {
   display: flex;
   justify-content: flex-start;
   align-items: center;
}

/* Flex box columns. */
.app-flex-column-around {
   display: flex;
   flex-direction: column;
   justify-content: space-around;
   align-items: center;
}

.app-flex-column-between {
   display: flex;
   flex-direction: column;
   justify-content: space-between;
   align-items: center;
}

.app-flex-column-center {
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
}

.app-flex-column-start {
   display: flex;
   flex-direction: column;
   justify-content: flex-start;
   align-items: center;
}

/* CSS for printing a div. */
@media print {
   body * {
      visibility: hidden;
      transform: scale(1);
      /* zoom: 100%; */
   }

   .hideForPrinting {
      width: 0;
      height: 0;
      overflow: hidden;
      display: none;
   }

   #print_div, #print_div * {
      visibility: visible;
   }

   #print_div {
      position: absolute;
      left: 0;
      top: 0;
      background-color: white;
      z-index: 999;
   }
}

/*==== Override ESRI popup. ====*/
.esri-popup__header-title {
   background-color: #CFD8DC;
}

/*=== Override ESRI navagation buttons. ===*/
.esri-widget--button {
   height: 36px;
   width: 36px;
}

.esri-widget--button, .esri-coordinate-conversion__heading .esri-coordinate-conversion__back-button {
   background-color: rgba(97, 125, 137, 0.95);
   color: white;
   border-radius: 5px;
}

.esri-widget--button:hover, .esri-coordinate-conversion__heading .esri-coordinate-conversion__back-button:hover {
   background-color: rgb(87, 107, 117);
   color: white;
}

calcite-button.esri-widget--button {
   --calcite-ui-text-1: white; /* Works for Compass icon. */
}

/* Needs work for Compass icon background color on hover  calcite-button.esri-widget--button:hover {
      --calcite-ui-text-1: red;
   }
*/
.esri-icon, .esri-icon-left-arrow, .esri-icon-right-arrow, .esri-icon-up, .esri-icon-down, .esri-icon-refresh,
.esri-icon-edit, .esri-icon-map-pin, .esri-icon-settings2, .esri-icon-duplicate, .esri-icon-search, .esri-icon-dial, .esri-icon-compass {
   /*color: white;*/
}

.esri-icon-close, .esri-icon-edit {
   color: silver; /* Restore icon colors. */
}

.esri-sketch__button.esri-icon-map-pin {
   color: grey; /* Restore sketch icon color. */
}

.esri-component.esri-zoom {
   background-color: transparent;
   box-shadow: none;
}

/*=== layerList. ===*/
.esri-layer-list__item-toggle-icon {
   font-size: 20px;
}

.esri-layer-list__item {
   background-color: #FFFFF0;
}

.esri-layer-list__item-container {
   background-color: #f5f5f5;
   padding: 7px 7px 4px 20px; /* top right bottom left */
   border: 1px solid #F0F0F0;
   border-radius: 2px;
}

.esri-layer-list__item--has-children > .esri-layer-list__list {
   font-size: 14px;
}

.esri-layer-list {
   font-size: 14px;
   color: darkslategray;
   font-weight: bold;
}

.esri-layer-list__item--invisible-at-scale .esri-layer-list__item-title, .esri-layer-list__item--invisible-at-scale .esri-layer-list__item-toggle {
   color: gray;
   font-weight: normal;
}

.esri-icon-non-visible::before {
   content: "\\e610"; /* Use checkbox icons. */
}

.esri-icon-visible::before {
   content: "\\e611"; /* Use checkbox icons. */
}

.esri-layer-list__item-action-icon {
   color: gray;
}

/*=== Copyright attribution. ===*/
.esri-attribution {
   background-color: rgba(255,255,255, 0.50);
   color: black;
}

/*=== Geocoding search widget ===*/
.esri-search {
   width: 325px;
}

.esri-search__input {
   margin-left: 5px;
   margin-right: 3px;
   border: 1px solid silver;
   border-radius: 3px;
}

/*=== Override ESRI map bottom status bar tools. ===*/
.esri-basemap-toggle__image {
   border-radius: 5px;
   border: 2px solid rgb(120,144,156);
}

/*=======================================*/
.esri-coordinate-conversion.esri-widget {
   width: 370px;
   background-color: rgba(120,144,156, 0.50);
   border-radius: 5px;
}

.esri-coordinate-conversion__display {
   /*color: black;*/
   background-color: rgba(210,220,225, 0.30);
   font-weight: bold;
}

.esri-coordinate-conversion__input-group label {
   background-color: rgba(210,220,225, 0.70);
}

.esri-coordinate-conversion__heading {
   background-color: rgba(120,144,156, 0.70);
}

.esri-coordinate-conversion__display:hover {
   background-color: rgb(210,220,225);
}

.esri-coordinate-conversion__select-row {
   background-color: rgba(210,220,225, 0.70);
}
/*=======================================*/
.esri-scale-bar__label-container--ruler .esri-scale-bar__label {
   padding: 0;
   padding-left: 2px;
   padding-right: 2px;
   color: black;
   background-color: rgba(255,255,255,0.70);
   margin-top: 3px;
   border-radius: 1px;
}

/*=== Override ESRI tool widgets. ===*/
.esri-bookmarks__bookmark-name {
   font-size: 14px;
   color: #4c4c4c;
}

.esri-basemap-gallery__item-title {
   font-size: 14px;
   color: black;
}

.esri-legend__layer-cell--info {
   font-size: 14px;
}
/*=== End override ESRI widgets. ===*/

`, "",{"version":3,"sources":["webpack://./app.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAG/D;GACG,kBAAkB;GAClB,yEAAyE;AAC5E;;AAEA,mBAAmB;AACnB;GACG,aAAa;GACb,6BAA6B;GAC7B,mBAAmB;AACtB;;AAEA;GACG,aAAa;GACb,8BAA8B;GAC9B,mBAAmB;AACtB;;AAEA;GACG,aAAa;GACb,uBAAuB;GACvB,mBAAmB;AACtB;;AAEA;GACG,aAAa;GACb,6BAA6B;GAC7B,mBAAmB;AACtB;;AAEA;GACG,aAAa;GACb,2BAA2B;GAC3B,mBAAmB;AACtB;;AAEA,sBAAsB;AACtB;GACG,aAAa;GACb,sBAAsB;GACtB,6BAA6B;GAC7B,mBAAmB;AACtB;;AAEA;GACG,aAAa;GACb,sBAAsB;GACtB,8BAA8B;GAC9B,mBAAmB;AACtB;;AAEA;GACG,aAAa;GACb,sBAAsB;GACtB,uBAAuB;GACvB,mBAAmB;AACtB;;AAEA;GACG,aAAa;GACb,sBAAsB;GACtB,2BAA2B;GAC3B,mBAAmB;AACtB;;AAEA,4BAA4B;AAC5B;GACG;MACG,kBAAkB;MAClB,mBAAmB;MACnB,gBAAgB;GACnB;;GAEA;MACG,QAAQ;MACR,SAAS;MACT,gBAAgB;MAChB,aAAa;GAChB;;GAEA;MACG,mBAAmB;GACtB;;GAEA;MACG,kBAAkB;MAClB,OAAO;MACP,MAAM;MACN,uBAAuB;MACvB,YAAY;GACf;AACH;;AAEA,iCAAiC;AACjC;GACG,yBAAyB;AAC5B;;AAEA,4CAA4C;AAC5C;GACG,YAAY;GACZ,WAAW;AACd;;AAEA;GACG,0CAA0C;GAC1C,YAAY;GACZ,kBAAkB;AACrB;;AAEA;GACG,mCAAmC;GACnC,YAAY;AACf;;AAEA;GACG,0BAA0B,EAAE,4BAA4B;AAC3D;;AAEA;;;CAGC;AACD;;GAEG,gBAAgB;AACnB;;AAEA;GACG,aAAa,EAAE,yBAAyB;AAC3C;;AAEA;GACG,WAAW,EAAE,+BAA+B;AAC/C;;AAEA;GACG,6BAA6B;GAC7B,gBAAgB;AACnB;;AAEA,qBAAqB;AACrB;GACG,eAAe;AAClB;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,yBAAyB;GACzB,yBAAyB,EAAE,0BAA0B;GACrD,yBAAyB;GACzB,kBAAkB;AACrB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,eAAe;GACf,oBAAoB;GACpB,iBAAiB;AACpB;;AAEA;GACG,WAAW;GACX,mBAAmB;AACtB;;AAEA;GACG,gBAAgB,EAAE,wBAAwB;AAC7C;;AAEA;GACG,gBAAgB,EAAE,wBAAwB;AAC7C;;AAEA;GACG,WAAW;AACd;;AAEA,iCAAiC;AACjC;GACG,yCAAyC;GACzC,YAAY;AACf;;AAEA,kCAAkC;AAClC;GACG,YAAY;AACf;;AAEA;GACG,gBAAgB;GAChB,iBAAiB;GACjB,wBAAwB;GACxB,kBAAkB;AACrB;;AAEA,qDAAqD;AACrD;GACG,kBAAkB;GAClB,kCAAkC;AACrC;;AAEA,0CAA0C;AAC1C;GACG,YAAY;GACZ,yCAAyC;GACzC,kBAAkB;AACrB;;AAEA;GACG,gBAAgB;GAChB,yCAAyC;GACzC,iBAAiB;AACpB;;AAEA;GACG,yCAAyC;AAC5C;;AAEA;GACG,yCAAyC;AAC5C;;AAEA;GACG,kCAAkC;AACrC;;AAEA;GACG,yCAAyC;AAC5C;AACA,0CAA0C;AAC1C;GACG,UAAU;GACV,iBAAiB;GACjB,kBAAkB;GAClB,YAAY;GACZ,wCAAwC;GACxC,eAAe;GACf,kBAAkB;AACrB;;AAEA,sCAAsC;AACtC;GACG,eAAe;GACf,cAAc;AACjB;;AAEA;GACG,eAAe;GACf,YAAY;AACf;;AAEA;GACG,eAAe;AAClB;AACA,qCAAqC","sourcesContent":["/* Load the ESRI javascript SDK css file. Custom! API Version */\r\n@import \"https://js.arcgis.com/4.28/@arcgis/core/assets/esri/themes/light/main.css\";\r\n\r\nbody {\r\n   overflow-y: hidden;\r\n   /*background-color: LightSteelBlue ivory cornsilk ghostWhite, gainsboro */\r\n}\r\n\r\n/* Flex box rows. */\r\n.app-flex-row-around {\r\n   display: flex;\r\n   justify-content: space-around;\r\n   align-items: center;\r\n}\r\n\r\n.app-flex-row-between {\r\n   display: flex;\r\n   justify-content: space-between;\r\n   align-items: center;\r\n}\r\n\r\n.app-flex-row-center {\r\n   display: flex;\r\n   justify-content: center;\r\n   align-items: center;\r\n}\r\n\r\n.app-flex-row-evenly {\r\n   display: flex;\r\n   justify-content: space-evenly;\r\n   align-items: center;\r\n}\r\n\r\n.app-flex-row-start {\r\n   display: flex;\r\n   justify-content: flex-start;\r\n   align-items: center;\r\n}\r\n\r\n/* Flex box columns. */\r\n.app-flex-column-around {\r\n   display: flex;\r\n   flex-direction: column;\r\n   justify-content: space-around;\r\n   align-items: center;\r\n}\r\n\r\n.app-flex-column-between {\r\n   display: flex;\r\n   flex-direction: column;\r\n   justify-content: space-between;\r\n   align-items: center;\r\n}\r\n\r\n.app-flex-column-center {\r\n   display: flex;\r\n   flex-direction: column;\r\n   justify-content: center;\r\n   align-items: center;\r\n}\r\n\r\n.app-flex-column-start {\r\n   display: flex;\r\n   flex-direction: column;\r\n   justify-content: flex-start;\r\n   align-items: center;\r\n}\r\n\r\n/* CSS for printing a div. */\r\n@media print {\r\n   body * {\r\n      visibility: hidden;\r\n      transform: scale(1);\r\n      /* zoom: 100%; */\r\n   }\r\n\r\n   .hideForPrinting {\r\n      width: 0;\r\n      height: 0;\r\n      overflow: hidden;\r\n      display: none;\r\n   }\r\n\r\n   #print_div, #print_div * {\r\n      visibility: visible;\r\n   }\r\n\r\n   #print_div {\r\n      position: absolute;\r\n      left: 0;\r\n      top: 0;\r\n      background-color: white;\r\n      z-index: 999;\r\n   }\r\n}\r\n\r\n/*==== Override ESRI popup. ====*/\r\n.esri-popup__header-title {\r\n   background-color: #CFD8DC;\r\n}\r\n\r\n/*=== Override ESRI navagation buttons. ===*/\r\n.esri-widget--button {\r\n   height: 36px;\r\n   width: 36px;\r\n}\r\n\r\n.esri-widget--button, .esri-coordinate-conversion__heading .esri-coordinate-conversion__back-button {\r\n   background-color: rgba(97, 125, 137, 0.95);\r\n   color: white;\r\n   border-radius: 5px;\r\n}\r\n\r\n.esri-widget--button:hover, .esri-coordinate-conversion__heading .esri-coordinate-conversion__back-button:hover {\r\n   background-color: rgb(87, 107, 117);\r\n   color: white;\r\n}\r\n\r\ncalcite-button.esri-widget--button {\r\n   --calcite-ui-text-1: white; /* Works for Compass icon. */\r\n}\r\n\r\n/* Needs work for Compass icon background color on hover  calcite-button.esri-widget--button:hover {\r\n      --calcite-ui-text-1: red;\r\n   }\r\n*/\r\n.esri-icon, .esri-icon-left-arrow, .esri-icon-right-arrow, .esri-icon-up, .esri-icon-down, .esri-icon-refresh,\r\n.esri-icon-edit, .esri-icon-map-pin, .esri-icon-settings2, .esri-icon-duplicate, .esri-icon-search, .esri-icon-dial, .esri-icon-compass {\r\n   /*color: white;*/\r\n}\r\n\r\n.esri-icon-close, .esri-icon-edit {\r\n   color: silver; /* Restore icon colors. */\r\n}\r\n\r\n.esri-sketch__button.esri-icon-map-pin {\r\n   color: grey; /* Restore sketch icon color. */\r\n}\r\n\r\n.esri-component.esri-zoom {\r\n   background-color: transparent;\r\n   box-shadow: none;\r\n}\r\n\r\n/*=== layerList. ===*/\r\n.esri-layer-list__item-toggle-icon {\r\n   font-size: 20px;\r\n}\r\n\r\n.esri-layer-list__item {\r\n   background-color: #FFFFF0;\r\n}\r\n\r\n.esri-layer-list__item-container {\r\n   background-color: #f5f5f5;\r\n   padding: 7px 7px 4px 20px; /* top right bottom left */\r\n   border: 1px solid #F0F0F0;\r\n   border-radius: 2px;\r\n}\r\n\r\n.esri-layer-list__item--has-children > .esri-layer-list__list {\r\n   font-size: 14px;\r\n}\r\n\r\n.esri-layer-list {\r\n   font-size: 14px;\r\n   color: darkslategray;\r\n   font-weight: bold;\r\n}\r\n\r\n.esri-layer-list__item--invisible-at-scale .esri-layer-list__item-title, .esri-layer-list__item--invisible-at-scale .esri-layer-list__item-toggle {\r\n   color: gray;\r\n   font-weight: normal;\r\n}\r\n\r\n.esri-icon-non-visible::before {\r\n   content: \"\\e610\"; /* Use checkbox icons. */\r\n}\r\n\r\n.esri-icon-visible::before {\r\n   content: \"\\e611\"; /* Use checkbox icons. */\r\n}\r\n\r\n.esri-layer-list__item-action-icon {\r\n   color: gray;\r\n}\r\n\r\n/*=== Copyright attribution. ===*/\r\n.esri-attribution {\r\n   background-color: rgba(255,255,255, 0.50);\r\n   color: black;\r\n}\r\n\r\n/*=== Geocoding search widget ===*/\r\n.esri-search {\r\n   width: 325px;\r\n}\r\n\r\n.esri-search__input {\r\n   margin-left: 5px;\r\n   margin-right: 3px;\r\n   border: 1px solid silver;\r\n   border-radius: 3px;\r\n}\r\n\r\n/*=== Override ESRI map bottom status bar tools. ===*/\r\n.esri-basemap-toggle__image {\r\n   border-radius: 5px;\r\n   border: 2px solid rgb(120,144,156);\r\n}\r\n\r\n/*=======================================*/\r\n.esri-coordinate-conversion.esri-widget {\r\n   width: 370px;\r\n   background-color: rgba(120,144,156, 0.50);\r\n   border-radius: 5px;\r\n}\r\n\r\n.esri-coordinate-conversion__display {\r\n   /*color: black;*/\r\n   background-color: rgba(210,220,225, 0.30);\r\n   font-weight: bold;\r\n}\r\n\r\n.esri-coordinate-conversion__input-group label {\r\n   background-color: rgba(210,220,225, 0.70);\r\n}\r\n\r\n.esri-coordinate-conversion__heading {\r\n   background-color: rgba(120,144,156, 0.70);\r\n}\r\n\r\n.esri-coordinate-conversion__display:hover {\r\n   background-color: rgb(210,220,225);\r\n}\r\n\r\n.esri-coordinate-conversion__select-row {\r\n   background-color: rgba(210,220,225, 0.70);\r\n}\r\n/*=======================================*/\r\n.esri-scale-bar__label-container--ruler .esri-scale-bar__label {\r\n   padding: 0;\r\n   padding-left: 2px;\r\n   padding-right: 2px;\r\n   color: black;\r\n   background-color: rgba(255,255,255,0.70);\r\n   margin-top: 3px;\r\n   border-radius: 1px;\r\n}\r\n\r\n/*=== Override ESRI tool widgets. ===*/\r\n.esri-bookmarks__bookmark-name {\r\n   font-size: 14px;\r\n   color: #4c4c4c;\r\n}\r\n\r\n.esri-basemap-gallery__item-title {\r\n   font-size: 14px;\r\n   color: black;\r\n}\r\n\r\n.esri-legend__layer-cell--info {\r\n   font-size: 14px;\r\n}\r\n/*=== End override ESRI widgets. ===*/\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
